import {DisplayFeature} from "../domain";
import * as React from "react";
import {connect} from "react-redux";
import classNames = require("classnames");
import * as selectors from "../selectors";
import {ToggleFeatureLock, toggleFeatureLock} from "../../../actions/actions";
import FeaturesState from "../domain/FeaturesState";

interface TagProps {
    feature: DisplayFeature;
}

interface StateProps {
    canToggleLock: boolean;
}

interface DispatchProps {
    doToggleFeatureLock: ToggleFeatureLock;
}

type ComponentProps = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        canToggleLock: selectors.userCanToggleFeatureLock(state),
    }
};

const mapDispatchToProps: DispatchProps = ({
    doToggleFeatureLock: toggleFeatureLock
});


class FeatureLockComponent extends React.Component<ComponentProps> {
    render() {
        let {feature} = this.props;

        let classes = classNames({
            "fas fa-unlock-alt"  : !feature.isLocked,
            "fas fa-lock"    : feature.isLocked,
            "feature-lock"  : true,
            "locked"        : feature.isLocked

        });

        return (
            <span title="Låste vegobjekter kan ikke redigeres" className={classes} onClick={(e) => this.handleClick(e)}  />
        );
    }

    handleClick(event: React.MouseEvent<HTMLSpanElement>) {
        let {doToggleFeatureLock, feature, canToggleLock} = this.props;
        event.stopPropagation();
        if (!canToggleLock) return;

        doToggleFeatureLock(feature.id, !feature.isLocked);

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureLockComponent);
